import { render, staticRenderFns } from "./BuildingEdit.vue?vue&type=template&id=194322e5&scoped=true"
import script from "./BuildingEdit.vue?vue&type=script&lang=js"
export * from "./BuildingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194322e5",
  null
  
)

export default component.exports